"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomBytes = void 0;
const getRandomBytes = () => {
    try {
        return require('mobileRandomBytes');
    }
    catch (error) {
        return require('randombytes');
    }
};
exports.randomBytes = getRandomBytes();
//# sourceMappingURL=randomBytes.js.map